export const LEAVE_EXTENSIONS_POST = 'LEAVE_EXTENSIONS_POST'
export const LEAVE_EXTENSIONS_POST_PENDING = 'LEAVE_EXTENSIONS_POST_PENDING'
export const LEAVE_EXTENSIONS_POST_FULFILLED = 'LEAVE_EXTENSIONS_POST_FULFILLED'
export const LEAVE_EXTENSIONS_POST_REJECTED = 'LEAVE_EXTENSIONS_POST_REJECTED'
